import { render } from "./WalletButton.vue?vue&type=template&id=f0af8950&ts=true"
import script from "./WalletButton.vue?vue&type=script&lang=ts"
export * from "./WalletButton.vue?vue&type=script&lang=ts"

import "./WalletButton.vue?vue&type=style&index=0&id=f0af8950&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__